/**
 * 请求响应拦截器
 */

import conf from '../_conf'
import store from '../../../store'
import { toast } from '../../toast'
import router from '../../../router'
import { setToken,removeToken } from '../../../handler/token.storage'

// 服务器返回码 2XX 内
export const responseSuccessInterceptor = response => {
  const token = response.headers.authorization || ''
  token && setToken(token)
  const responseBody = response.data || {}
  if (responseBody.code !== '0') {
    toast('网络异常！')
  }
  return responseBody
}

// 服务器返回码不在 2XX 内
export const responseErrorInterceptor = error => {
  if (error.response) {
    const httpCode = error.response.status
    if (conf.AUTH_CODE.includes(httpCode)) {
      // 删除本地token
      removeToken()

      // 设置登录状态
      store.commit('user/setLoginStatus',0)

      // 处理auth参数
      const name = router.currentRoute.name || ''
      const query = router.currentRoute.query || {}

      router.replace({
        name: 'auth_page',
        query: {
          ...query,
          page: name
        }
      })
    } else if (httpCode === 500 && error.response.data.code === 'System_1') {
      toast('网络异常！')
    } else {
      toast('网络异常！')
    }
  } else {
    toast('网络异常！')
  }

  return Promise.reject(error)
}
